import { useAppEnvConfig, useAuthentication } from '@connect-x-app/hybrid-state';
import { useFeatureFlags } from '@connect-x-app/hybrid-utils';
import { ADMIN_CONFIG_PERMISSIONS } from '@connect-x-app/shared-domain-models';

export const useConnectedTurnaroundAccess = () => {
  const { isConnectedTurnaroundEnabled } = useFeatureFlags();
  const { env } = useAppEnvConfig();
  const { hasAnyPermission } = useAuthentication();

  return isConnectedTurnaroundEnabled && !!env?.connectedTurnaroundServiceUrl && hasAnyPermission(ADMIN_CONFIG_PERMISSIONS);
};
